import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Section, Text } from "../../components/Core";


const Sharptree = () => {

  const data = useStaticQuery(graphql`
    query {
      sharptree_horizontal_logo: file(relativePath: { eq: "sharptree_horizontal_logo.png" }) {
        childImageSharp {
          fixed(height: 70) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <>
      <Section className="position-relative" bg="greyBackground">
        <Container>
          <Row className="justify-content-center pb-4">
            <Col lg="5" className="pb-5">
              <Img fixed={data.sharptree_horizontal_logo.childImageSharp.fixed} />
            </Col>
            <Col lg="7" className="pl-lg-5">
              <Text>
                Maximo is not your business, but it is ours. We are using our years of experience to identify
                and address the challenges of implementing complex processes in Maximo in a way that makes them
                simple, approachable and even enjoyable.
              </Text>
              <Text mt={3}>
                All this is so Maximo can support growing and evolving your business and not be an obstacle to it.
                Not just directly for your Maximo users, but also for your field workers, managers, and administrators.
              </Text>
              <Text mt={3}>
                Check out <a href="https://sharptree.io" target="_blank" rel="noopener noreferrer"><u>our site</u></a> for more information.
              </Text>
            </Col>
          </Row>
        </Container>
      </Section>
    </>
  );
};

export default Sharptree;
